
























































































import { Component, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { TSyncableTableWithDelay } from '@/plugins/podolib/services/entities/mixins/entities';
import { Severity } from '@sentry/types';

@Component<MixinDialog>({
  mounted() {
    if (this.listenBus) {
      this.$pdc.bus!.on('acquisition:start', this.open);
    }
  },
  beforeDestroy() {
    if (this.listenBus) {
      this.$pdc.bus!.off('acquisition:start', this.open);
    }
  },
})
export default class HomeNewAcquisition extends MixinDialog {
  private patients = [];
  private selectedPatient: string | null = null;
  private search = {
    fields: ['infos.firstName', 'infos.lastName', 'infos.birthDate', 'infos.footSize'],
    value: '',
  };
  private previousKeyword: string | null = null;
  private pending = false;
  private lock = false;
  private delay: TSyncableTableWithDelay['delay'] = {
    config: 400,
    timeout: undefined,
  };
  private error: Error | null = null;

  @Watch('search.value')
  private async onSearchChange(newValue: any) {
    if (!newValue) return;
    // Set "loading" flag
    this.pending = true;
    // Clear previous timeout
    if (this.delay.timeout) clearTimeout(this.delay.timeout);

    if (this.search.value?.length) {
      this.delay.timeout = setTimeout(() => {
        return this.searchPatient(newValue);
      }, this.delay.config);
    } else if (!this.selectedPatient) {
      return this.searchPatient(newValue);
    }
  }

  clear() {
    // Clear timeout
    if (this.delay.timeout) clearTimeout(this.delay.timeout);

    this.$nextTick(() => {
      // Reset 'pending' flag
      this.pending = false;
      // Reset 'lock' flag
      this.lock = false;
    });
  }

  private async searchPatient(keyword: any) {
    const query = {} as any;
    // If search is available...
    if (keyword?.length) {
      query['$or'] = this.search.fields.map((x) => {
        if (x === 'infos.footSize') {
          return {
            [x]: parseFloat(keyword) || 0,
          };
        }
        if (x === 'infos.birthDate') {
          return {
            [x]: '',
          };
        }
        return {
          [x]: {
            $regex: `(.*)${keyword}(.*)`,
            $options: 'i',
          },
        };
      });
    }

    try {
      // Set "loading" flag
      this.pending = true;
      // Try to search patients...
      const response = await this.$pdc.entities!.patients.search(keyword, { query, replace: false });
      // Analytics
      /*this.$pdc.analytics?.actions.trackSuccess(
        'Home NewAnalysis Search',
        {
          keyword
        },
        {
          keyword: this.previousKeyword
        }
      );*/
      // Save keyword
      this.previousKeyword = keyword;
      // Set 'patients' array (exclude current patient)
      this.patients = response.data.filter((x: any) => x._id !== this.$route.params.id);
    } catch (e) {
      // Analytics
      /*this.$pdc.analytics?.actions.trackFailure(
        'Home NewAnalysis Search',
        e,
        {
          keyword
        },
        {
          keyword: this.previousKeyword
        }
      );*/
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset "loading" flag
      this.pending = false;
    }
  }

  @Watch('selectedPatient')
  async onSelectedPatientChanged(patientId: string) {
    this.clear();

    if (patientId) {
      // Analytics
      /*this.$pdc.analytics?.actions.trackSuccess('Home NewAnalysis Select', {
        patientId
      });*/
    }
  }

  clearInput() {
    // Analytics
    // this.$pdc.analytics?.actions.trackSuccess('Home NewAnalysis Clear');
  }

  goToAcquisition() {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('NewAnalysis Opened', {
      patientId: this.selectedPatient,
    });
    // Redirect...
    this.$router.push({
      path: '/analysis',
      query: {
        patientId: this.selectedPatient,
      },
    });
    // Analytics
    /*this.$pdc.analytics?.actions.trackSuccess('Home NewAnalysis Start', {
      patientId: this.selectedPatient
    });*/
  }

  _open() {
    this.open();
    // Analytics
    //this.$pdc.analytics?.actions.trackSuccess('Home NewAnalysis Open');
  }

  _close() {
    this.close();
    // Analytics
    // this.$pdc.analytics?.actions.trackSuccess('Home NewAnalysis Close');
  }
}
